export class VisitaCertificacion {

    public idCompania: string;
    public idVisita: string;
    public idCertificacion: string;
    public firma: string;
    public longitud: string;
    public latitud: string;
    public fecha: Date;
    public nombreFirma: string;

}
